<div class="general-simple-box overflow-hidden">
  <div class="flex flex-col gap-4 bg-(--comp-app-bg)">
    <div class="flex flex-col">
      <div class="bg-(--color-segundo) p-6 text-white flex flex-col gap-2">
        <div class="items-center flex font-semibold text-base">
          {{ 'maintenance.modify-dates.title' | translate }}
        </div>
        <div class="flex items-center font-normal text-base">
          @if (step2 || step1) {
            {{ 'maintenance.modify-dates.steps.selectQuotation' | translate }}
          }
          @if (step3) {
            {{ 'maintenance.modify-dates.steps.editValidity' | translate }}
          }
        </div>
      </div>
    </div>

    <!-- <div class="bg-(--comp-app-bg) p-4 flex justify-between items-center">
        <div class="flex flex-col gap-2">
          <div class="font-medium text-base">
            {{ 'maintenance.modify-dates.search.title' | translate }}
          </div>
          <div class="text-general text-(--brand-gray-dark)">
            {{ 'maintenance.modify-dates.search.description' | translate }}
          </div>
        </div>
        <div class="flex gap-2">
          <app-input-general
            class="min-w-60 lg:min-w-80"
            [formControlGeneral]="searchQuotation"
            [label]="'maintenance.modify-dates.search.quotationLabel' | translate"
            [placeholder]="'maintenance.modify-dates.search.quotationPlaceholder' | translate"
          ></app-input-general>
        </div>
      </div> -->
  </div>

  @if (step3) {
    <div class="bg-(--comp-app-bg) p-4">
      <div class="general-simple-box overflow-hidden">
        <div class="flex">
          <div class="flex flex-col w-full">
            <div
              class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
            >
              {{ 'maintenance.modify-dates.summary.quotation' | translate }}
            </div>
            <div
              class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
            >
              {{ quotationContract?.idCotizacion }}
            </div>
          </div>
          <div class="flex flex-col w-full">
            <div
              class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
            >
              {{ 'maintenance.modify-dates.summary.name' | translate }}
            </div>
            <div
              class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
            >
              {{ quotationContract?.nombreCompleto }}
            </div>
          </div>
          <div class="flex flex-col w-full">
            <div
              class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
            >
              {{ 'maintenance.modify-dates.summary.term' | translate }}
            </div>
            <div
              class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
            >
              {{ quotationContract?.desPlazo1 }}
            </div>
          </div>
          <div class="flex flex-col w-full">
            <div
              class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
            >
              {{ 'maintenance.modify-dates.summary.startDate' | translate }}
            </div>
            <div
              class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
            >
              {{ quotationContract?.fechaInicio }}
            </div>
          </div>
          <div class="flex flex-col w-full">
            <div
              class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
            >
              {{ 'maintenance.modify-dates.summary.endDate' | translate }}
            </div>
            <div
              class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
            >
              {{ quotationContract?.fechaTermino }}
            </div>
          </div>
          <!-- <div class="flex flex-col w-full">
              <div
                class="bg-(--color-segundo) px-2 py-2 justify-center items-center flex font-semibold text-base text-white"
              >
                Acción
              </div>
              <div
                class="bg-white px-2 py-2 flex justify-center items-center h-14 font-semibold text-base"
              >
                <button matButton="filled" class="button-general h-10!">Modificar fechas</button>
              </div>
            </div> -->
        </div>

        <div class="general-simple-box-light"></div>

        <div class="p-4 flex flex-col gap-4">
          <div class="flex flex-col gap-2">
            <div class="font-medium text-base text-(--brand-gray-dark)">
              {{ 'maintenance.modify-dates.edition.title' | translate }}
            </div>
            <div class="text-general">
              {{ 'maintenance.modify-dates.edition.description' | translate }}
            </div>
          </div>

          <div class="flex gap-3">
            <div
              class="general-simple-box-light flex flex-col gap-1 w-full bg-(--comp-app-bg)! overflow-hidden p-3"
            >
              <div class="font-medium text-base text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.title' | translate }}
              </div>
              <div class="text-general">{{ quotationContract?.nombreCompleto }}</div>
            </div>
            <div
              class="general-simple-box-light flex flex-col gap-1 w-full bg-(--comp-app-bg)! overflow-hidden p-3"
            >
              <div class="font-medium text-base text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.summary.term' | translate }}
              </div>
              <div class="text-general">{{ quotationContract?.desPlazo1 }}</div>
            </div>
            <div
              class="general-simple-box-light flex flex-col gap-1 w-full bg-(--comp-app-bg)! overflow-hidden p-3"
            >
              <div class="font-medium text-base text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.currentStartDate' | translate }}
              </div>
              <div class="text-general">{{ quotationContract?.fechaInicio }}</div>
            </div>
            <div
              class="general-simple-box-light flex flex-col gap-1 w-full bg-(--comp-app-bg)! overflow-hidden p-3"
            >
              <div class="font-medium text-base text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.currentEndDate' | translate }}
              </div>
              <div class="text-general">{{ quotationContract?.fechaTermino }}</div>
            </div>
          </div>

          <div class="flex gap-3">
            <div class="general-simple-box-light flex flex-col gap-3 w-full overflow-hidden p-4">
              <div class="font-medium text-base">
                {{ 'maintenance.modify-dates.edition.newStartDate' | translate }}
              </div>
              <div class="text-general text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.calendarHelp' | translate }}
              </div>

              <app-input-general-calendar
                [formControlGeneral]="newDate"
                [label]="'maintenance.modify-dates.edition.calendarLabel' | translate"
                [placeholder]="'maintenance.modify-dates.edition.calendarPlaceholder' | translate"
              >
              </app-input-general-calendar>
            </div>

            <div class="general-simple-box-light flex flex-col gap-3 w-full overflow-hidden p-4">
              <div class="font-medium text-base">
                {{ 'maintenance.modify-dates.edition.recalculatedEndDate' | translate }}
              </div>
              <div class="text-general text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.recalculatedEndDateDescription' | translate }}
              </div>

              <div
                class="general-simple-box-light flex flex-col gap-1 w-full overflow-hidden p-5 bg-[#eff9ff]"
              >
                <div class="font-medium text-base text-(--brand-azul-primario) text-center">
                  {{ 'maintenance.modify-dates.edition.newResult' | translate }}
                </div>
                <div class="font-semibold text-2xl text-center">
                  {{
                    newDateEnd
                      ? newDateEnd.toLocaleDateString('es-MX')
                      : ('maintenance.modify-dates.edition.selectNewDate' | translate)
                  }}
                </div>
              </div>
              <div class="text-general text-(--brand-gray-dark)">
                {{ 'maintenance.modify-dates.edition.reference' | translate }}
              </div>
            </div>
          </div>
          <div class="general-simple-box-light"></div>
          <div class="flex gap-3 justify-end">
            <button
              (click)="deleteQuotation()"
              class="button-general-border h-11! text-center w-auto"
              matButton="filled"
            >
              {{ 'maintenance.modify-dates.actions.cancel' | translate }}
            </button>
            <button
              [disabled]="newDate.invalid"
              (click)="saveNewDate()"
              class="button-general h-11! text-center w-auto"
              matButton="filled"
            >
              {{ 'maintenance.modify-dates.actions.save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (step2) {
    <div class="p-4">
      <app-table-general-simple
        [dataSource]="dataSource"
        [headers]="headers"
        [buttonEvent]="false"
        [menuButton]="[
          {
            icon: quotationContract?.canModify ? 'check_circle' : '',
            iconFile: quotationContract?.canModify ? '' : 'alerta_amarillo',
            key: quotationContract?.canModify ? 'notModify' : 'Modify',
            text: quotationContract?.canModify
              ? ('maintenance.modify-dates.table.modifiable' | translate)
              : ('maintenance.modify-dates.table.cannotModify' | translate),
          },
        ]"
        (endElementEmitter)="selectQuotation($event.element)"
      ></app-table-general-simple>
    </div>
  }
</div>

<app-load-general [load]="loadService"></app-load-general>
